export default __webpack_public_path__ + "static/media/JapanTrip1.8a79921a.jpg";